import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import { status_aktif } from '../../constants/general'
import Dropzone from 'react-dropzone'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { MEDIA_HOST } from '../../constants/siteConfig'
import Select from "react-select";

const dataLevel = [
    { key: "online", value: "Tugas Online" },
    { key: "offline", value: "Tugas Offline" }
]

class Forms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tugas_id        : "",
            tugas_judul     : "",
            tugas_desc      : "",
            tugas_status    : "",
            kelas_id        : "",
            kelasNew        : "",
            mapel_id        : "",
            user_id         : "",
            urlVideo        : "",
            tugas_file_exist: [],
            tugas_file      : [],
            dataKelas       : [],
            dataMapel       : [],
            dataGuru       : [],
            dueDate         : moment().format('YYYY-MM-DD HH:mm:ss'),
            dueDateMoment   : moment(),
            isButtonLoading : false,
            isLoadingDataKelas: false,
            isLoading       : false,
            isUploadLoading : false,
            tugasFileNama : []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeDatepicker = this.handleChangeDatepicker.bind(this);
        this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);

    }


    handleChangeMultiSelect(stateName, text) {
        this.setState({[stateName]: text});

        if (stateName == 'participants') {
            let kelas = [];
            for (var i = 0; i < text.length; i++) {
                kelas.push(text[i].value);
            }

            const kelasNew = kelas.join(',');

            this.setState({
                kelasNew
            });
        }

    }

    handleChangeDatepicker(momentObj, momentStateName, stateName) {
        const newState = {}
        newState[momentStateName]   = momentObj
        newState[stateName]         = momentObj.format('YYYY-MM-DD HH:mm:ss')
        this.setState(newState)
    }

    handleChange(event) {
        const target = event.target;
        const value  = target.type === 'checkbox' ? target.checked : target.value;
        const name   = target.name;
        this.setState({
            [name]: value
        })        
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        
        // if ([]) {
        //     formData.append('tugas_file', this.state.tugas_file[0])
        // }else{
        //     formData.append('tugas_file', '')
        // }

        formData.append('tugas_file', this.state.tugasFileNama)
        formData.append('tugas_id', this.state.tugas_id)
        formData.append('tugas_judul', this.state.tugas_judul)
        formData.append('tugas_desc', this.state.tugas_desc)
        formData.append('user_login', localStorage.SISMART_USER_ID)
        formData.append('tugas_status', this.state.tugas_status)
        formData.append('mapel_id', this.state.mapel_id)
        formData.append('kelas_id', this.state.kelasNew)
        formData.append('user_id', this.state.user_id)
        formData.append('tugas_due_date', this.state.dueDate)
        formData.append('locale', "id")
        formData.append('platform', "web")
        formData.append('urlVideo', this.state.urlVideo)

        const url = this.props.mode === "Tambah" ? "tugas/create" : "tugas/update"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;
                console.log(result)
                if (result.status) {
                    Alert.success(result.text)
                    this.props.history.replace("/tugas")
                }
                else {
                    if (Array.isArray(result.text)) {

                        result.text.map(item => {
                            Alert.error(item)
                            return true
                        })
                    }
                    else {
                        Alert.error(result.text)
                    }
                    this.setState({ isButtonLoading: false })
                }             
            }) 
            .catch(error => {
                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.tugasFileNama
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            tugasFileNama: copiedStateFiles
        })
    }

    onDrop(files) {
        this.setState({ isUploadLoading: true })

        const newState = this.state.tugas_file.concat(files)
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        newState.map((item, i) => {
            formData.append('file'+i, item);
        })

        formData.append('fitur', 'tugas');
        formData.append('jumFile', newState.length);

        const url = "file"
        axios.post(url, formData, config)
        .then(response => {
            const result = response.data;

            if (result.status) {
                Alert.success(result.text);
                    result.data.map(item=>{
                        this.setState({
                            tugasFileNama: this.state.tugasFileNama.concat(item['filename']),
                        });
                    })
                this.setState({
                    isUploadLoading: false
                },()=>{
                    console.log(this.state.tugasFileNama)
                });
            }
            else {
                Alert.error(result.text);
                this.setState({ isUploadLoading: false })
            }
        })
        .catch(error => {
            console.log("ERROR", error)
            Alert.error("Gagal terhubung ke server!")
            this.setState({ isUploadLoading: false })
        })



    }

    loadData() {

        if (this.props.mode === "Edit") {  
            
            this.setState({ isLoading: true })

            const params = qs.stringify({
                locale:"id",
                platform:"web",
                userId:localStorage.SISMART_USER_ID,
                tugas_id:this.props.match.params.tugas_id
            })

            axios({
                method: 'post',
                url: '/tugas/detail?' + params
            })

            .then(response => {
                const result = response.data
                
                if (result.status) {

                    this.setState({
                        tugas_id        : result.data.tugas[0].tugas_id,
                        tugas_judul     : result.data.tugas[0].tugas_judul,
                        tugas_desc      : result.data.tugas[0].tugas_desc,
                        tugas_status    : result.data.tugas[0].tugas_status,
                        kelas_id        : result.data.tugas[0].kelas_id.split(","),
                        mapel_id        : result.data.tugas[0].mapel_id,
                        user_id         : result.data.tugas[0].user_id,
                        urlVideo         : result.data.tugas[0].video,
                        dueDateMoment   : moment(result.data.tugas[0].tugas_due_date),
                        dueDate   : result.data.tugas[0].tugas_due_date,

                        tugas_file_exist: [
                            ...result.data.tugas[0].tugas_file
                        ],
                        isLoading       : false
                    });

                    var data_kelas_id = []

                    for (var i=0; i<this.state.kelas_id.length; i++) {
                        var arr_kelas_id =[]
                        arr_kelas_id["kelas_id"]= this.state.kelas_id[i]
                        data_kelas_id[i] = arr_kelas_id
                    }

                    const participants = data_kelas_id.map(
                        item => item.kelas_id
                    );

                    const kelasNew = data_kelas_id.map(item => ({
                        "kelas_id": item.kelas_id
                    }));

                    const newFiileName = result.data.tugas[0].tugas_file.map(item=>item.tugas_file_nama);

                    this.setState(
                        {
                            kelasNew: participants.join(","),
                            participants: participants.join(","),
                            tugasFileNama : newFiileName
                        }
                    );

                }   
                else {

                    Alert.error(result.text)
                    this.setState({ isLoading: false })
                }                    

            })
            .catch((error) => {
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isLoading: false })
            })
        }
        
    }

    loadDataKelas() {
        this.setState({isLoadingDataKelas: true});

        const params = qs.stringify({
            locale: "id",
            platform: "web"
        })
        axios({
            method: 'post',
            url: '/kelas'
        })

            .then(response => {
                const result = response.data;
                if (result.success) {
                    const dataKelas = result.data.map(item => ({
                        value: item.kelas_id,
                        label: item.kelas_nama
                    }));

                    this.setState({
                        dataKelas,
                        isLoadingDataKelas: false
                    });
                } else {
                    if (Array.isArray(result.text)) {
                        result.text.map(item => {
                            Alert.error(item);

                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({isLoadingDataKelas: false});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({isLoadingDataKelas: false});
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataGuru() {
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            userId:localStorage.SISMART_USER_ID
        })
        
        axios({
            method: 'post',
            url: '/guru?' + params
        })

        .then(response => {
            console.log(response.data.data)
            return response.data.data.map(item => ({
                key: item.user_id,
                value: item.user.user_nama
            }))
        })

        .then(result => {
            this.setState({
                dataGuru: result
            })
        })

        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Data Mapel/Kelas/Jadwal Mungkin belum lengkap!")
        })
    }

    loadDataMapel() {
        const params = qs.stringify({
            locale:"id",
            platform:"web",
            userId:localStorage.SISMART_USER_ID
        })
        
        axios({
            method: 'post',
            url: '/mapel?' + params
        })

        .then(response => {
            return response.data.mapelexport.map(item => ({
                key: item.mapel_id,
                value: item.mapel_nama
            }))
        })
        .then(result => {
            this.setState({
                dataMapel: result
            })
        })

        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Data Mapel/Kelas/Jadwal Mungkin belum lengkap!")
        })
    }

    componentDidMount() {
        this.loadData()
        this.loadDataKelas()
        this.loadDataGuru()
        this.loadDataMapel()
    }

    
    render() {
        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        {this.props.mode} Data Tugas Siswa
                    </div>
                    <div className="card-block">
                    {
                        this.state.isLoading ? 'Memuat Data...' : (
                            <div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">
                                        Kelas yang mengikuti
                                    </label>
                                    <div className="col-md-10">
                                        <Select
                                            multi
                                            value={this.state.participants}
                                            onChange={text =>
                                                this.handleChangeMultiSelect("participants", text)
                                            }
                                            options={this.state.dataKelas}
                                            placeholder="Kelas yang mengikuti"
                                            removeSelected={this.state.removeSelected}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Mapel</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataMapel}
                                            onChange={this.handleChange}
                                            value={this.state.mapel_id.toString()}
                                            name="mapel_id"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Guru</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={this.state.dataGuru}
                                            onChange={this.handleChange}
                                            value={this.state.user_id.toString()}
                                            name="user_id"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Judul Tugas</label>
                                    <div className="col-md-10">
                                        <input 
                                            name="tugas_judul"
                                            type="text"
                                            className="form-control"
                                            placeholder="Nama Judul Tugas" 
                                            onChange={this.handleChange} 
                                            value={this.state.tugas_judul} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Deskripsi Tugas</label>
                                    <div className="col-md-10">
                                        <textarea
                                            name="tugas_desc"
                                            className="form-control"
                                            placeholder="Deskripsi Tugas"
                                            onChange={this.handleChange}
                                            value={this.state.tugas_desc} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Batas Pengumpulan</label>
                                    <div className="col-md-10">
                                        <DatePicker
                                            selected={this.state.dueDateMoment}
                                            onChange={(momentObj) => {
                                                this.handleChangeDatepicker(momentObj, "dueDateMoment", "dueDate")
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            dateFormat="DD-MM-YYYY HH:mm"
                                            timeFormat="HH:mm"
                                            timeIntervals={1}
                                            timeCaption="time"
                                            dropdownMode="select"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Status Aktif</label>
                                    <div className="col-md-10">
                                        <FormDropdown
                                            items={status_aktif}
                                            onChange={this.handleChange}
                                            value={this.state.tugas_status}
                                            name="tugas_status"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Lampiran Video</label>
                                    <div className="col-md-10">
                                        <input
                                            name="urlVideo"
                                            type="text"
                                            className="form-control"
                                            placeholder="Url Lampiran Video"
                                            onChange={this.handleChange}
                                            value={this.state.urlVideo} />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Tugas</label>
                                    <div className="col-md-12">

                                        <Dropzone
                                            onDrop={this.onDrop.bind(this)}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                border: "2px dashed #e9e9e9",
                                                padding: "20px 30px",
                                                color: "#888",
                                                cursor: "pointer",
                                                textAlign: "center",
                                                marginBottom: "15px"
                                            }}
                                        >
                                            {
                                                !this.state.isUploadLoading ? (
                                                    <div>Klik atau drop file disini untuk mengupload file <br/>
                                                        (.doc .docx .xls .xlsx .ppt .pptx .pdf .jpg dan maksimal 2MB)</div>
                                                ) : (
                                                    <div className="loader" style={{
                                                        borderLeft: '15px solid #20a8d8'
                                                    }}></div>
                                                )
                                            }

                                        </Dropzone>

                                        <ul>
                                            {
                                                this.state.tugasFileNama.map((item, index) =>
                                                    <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                        {item} {" "}
                                                        <button
                                                            title="Hapus"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.handleDeleteFile(index)}
                                                            type="button"
                                                        >
                                                            <i className="fa fa-remove"></i>
                                                        </button>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                    <label className="col-md-12 form-control-label">
                                        <strong>*Format yang di dukung : .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg</strong><br/>
                                        <strong>*Maksimal ukuran file 2MB</strong><br/>
                                    </label>
                                </div>                                
                            </div>
                        )
                    }                    
                    </div>
                    <div className="card-footer">
                        <button 
                            type="button" 
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Simpan"}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Forms;


// WEBPACK FOOTER //
// ./src/views/Tugas/Forms.js